/* CarlCursorTemplate — Theme JavaScript */
(function() {
  'use strict';

  /* ===== Utility Helpers ===== */
  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.from((root || document).querySelectorAll(sel)); }
  function on(el, evt, fn, opts) { if (el) el.addEventListener(evt, fn, opts); }
  function off(el, evt, fn) { if (el) el.removeEventListener(evt, fn); }

  function fetchJSON(url, opts) {
    return fetch(url, Object.assign({ headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' } }, opts))
      .then(function(r) { return r.json(); });
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function debounce(fn, ms) {
    var timer;
    return function() {
      var ctx = this, args = arguments;
      clearTimeout(timer);
      timer = setTimeout(function() { fn.apply(ctx, args); }, ms);
    };
  }

  /* ===== AJAX Cart ===== */
  var Cart = {
    get: function() {
      return fetchJSON('/cart.js');
    },
    add: function(id, qty) {
      return fetchJSON('/cart/add.js', {
        method: 'POST',
        body: JSON.stringify({ items: [{ id: id, quantity: qty || 1 }] })
      });
    },
    change: function(line, qty) {
      return fetchJSON('/cart/change.js', {
        method: 'POST',
        body: JSON.stringify({ line: line, quantity: qty })
      });
    },
    update: function(updates) {
      return fetchJSON('/cart/update.js', {
        method: 'POST',
        body: JSON.stringify({ updates: updates })
      });
    },
    clear: function() {
      return fetchJSON('/cart/clear.js', { method: 'POST' });
    }
  };

  /* ===== Cart Drawer ===== */
  var CartDrawer = {
    el: null,
    panel: null,
    overlay: null,

    init: function() {
      this.el = qs('#cart-drawer');
      if (!this.el) return;
      this.panel = qs('.cart-drawer-panel', this.el);
      this.overlay = qs('.cart-drawer-overlay', this.el);

      var self = this;
      qsa('.cart-drawer-trigger').forEach(function(btn) {
        on(btn, 'click', function(e) { e.preventDefault(); self.open(); });
      });
      on(this.overlay, 'click', function() { self.close(); });
      qsa('.cart-drawer-close', this.el).forEach(function(btn) {
        on(btn, 'click', function() { self.close(); });
      });
      on(document, 'keydown', function(e) {
        if (e.key === 'Escape' && self.isOpen()) self.close();
      });
    },

    isOpen: function() {
      return this.el && !this.el.classList.contains('hidden');
    },

    open: function() {
      if (!this.el) return;
      this.el.classList.remove('hidden');
      this.el.setAttribute('aria-hidden', 'false');
      document.body.classList.add('overflow-hidden');
      if (this.panel) {
        this.panel.style.transform = 'translateX(100%)';
        requestAnimationFrame(function() {
          this.panel.style.transition = 'transform 0.3s ease';
          this.panel.style.transform = 'translateX(0)';
        }.bind(this));
      }
      this.refresh();
    },

    close: function() {
      if (!this.el) return;
      var self = this;
      if (this.panel) {
        this.panel.style.transform = 'translateX(100%)';
        setTimeout(function() {
          self.el.classList.add('hidden');
          self.el.setAttribute('aria-hidden', 'true');
          document.body.classList.remove('overflow-hidden');
          if (self.panel) self.panel.style.transition = '';
        }, 300);
      } else {
        this.el.classList.add('hidden');
        this.el.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('overflow-hidden');
      }
    },

    refresh: function() {
      var self = this;
      Cart.get().then(function(cart) {
        self.render(cart);
        self.updateBubbles(cart.item_count);
      });
    },

    updateBubbles: function(count) {
      qsa('.cart-count-bubble').forEach(function(el) {
        el.textContent = count;
        el.style.display = count > 0 ? 'flex' : 'none';
      });
      qsa('.cart-count').forEach(function(el) {
        el.textContent = count;
      });
    },

    render: function(cart) {
      var self = this;
      var content = qs('.cart-drawer-content', this.el);
      if (!content) return;

      if (cart.item_count === 0) {
        content.innerHTML =
          '<div class="flex-1 flex flex-col items-center justify-center p-4">' +
            '<p class="text-muted-foreground text-center py-12">Your cart is empty</p>' +
            '<a href="/" class="btn btn-primary w-full text-center">Continue shopping</a>' +
          '</div>';
        return;
      }

      var html = '<div class="flex-1 overflow-auto p-4"><div class="space-y-4">';
      cart.items.forEach(function(item, idx) {
        html += '<div class="flex gap-4 border-b border-border pb-4" data-line="' + (idx + 1) + '">' +
          '<div class="w-20 h-20 flex-shrink-0 rounded overflow-hidden bg-muted">';
        if (item.image) {
          html += '<img src="' + self.getSizedImage(item.image, '160x') + '" alt="' + self.escAttr(item.title) + '" class="w-full h-full object-cover" loading="lazy">';
        }
        html += '</div><div class="flex-1 min-w-0">' +
          '<a href="' + item.url + '" class="font-medium text-foreground hover:text-primary text-sm">' + item.product_title + '</a>';
        if (item.variant_title && item.variant_title !== 'Default Title') {
          html += '<p class="text-xs text-muted-foreground">' + item.variant_title + '</p>';
        }
        html += '<p class="text-primary font-medium mt-1 text-sm">' + formatMoney(item.final_line_price) + '</p>' +
          '<div class="flex items-center gap-2 mt-2">' +
            '<div class="flex items-center border border-border rounded">' +
              '<button type="button" class="cart-qty-btn px-2 py-1 text-sm" data-line="' + (idx + 1) + '" data-action="minus">−</button>' +
              '<span class="px-2 py-1 text-sm min-w-[40px] text-center">' + item.quantity + '</span>' +
              '<button type="button" class="cart-qty-btn px-2 py-1 text-sm" data-line="' + (idx + 1) + '" data-action="plus">+</button>' +
            '</div>' +
            '<button type="button" class="cart-remove-btn text-sm text-muted-foreground hover:text-destructive" data-line="' + (idx + 1) + '">Remove</button>' +
          '</div></div></div>';
      });
      html += '</div></div>';
      html += '<div class="border-t border-border p-4">' +
        '<div class="flex justify-between text-lg font-semibold mb-4"><span>Total</span><span>' + formatMoney(cart.total_price) + '</span></div>' +
        '<a href="/checkout" class="btn btn-primary w-full text-center block">Checkout</a>' +
      '</div>';

      content.innerHTML = html;
      self.bindCartEvents();
    },

    escAttr: function(s) { return String(s).replace(/"/g, '&quot;').replace(/</g, '&lt;'); },

    getSizedImage: function(src, size) {
      if (!src) return '';
      return src.replace(/(\.[^.]+)$/, '_' + size + '$1');
    },

    bindCartEvents: function() {
      var self = this;
      qsa('.cart-qty-btn', this.el).forEach(function(btn) {
        on(btn, 'click', function() {
          var line = parseInt(this.dataset.line);
          var action = this.dataset.action;
          var span = this.parentElement.querySelector('span');
          var qty = parseInt(span.textContent);
          var newQty = action === 'plus' ? qty + 1 : Math.max(0, qty - 1);
          Cart.change(line, newQty).then(function(cart) {
            self.render(cart);
            self.updateBubbles(cart.item_count);
          });
        });
      });
      qsa('.cart-remove-btn', this.el).forEach(function(btn) {
        on(btn, 'click', function() {
          var line = parseInt(this.dataset.line);
          Cart.change(line, 0).then(function(cart) {
            self.render(cart);
            self.updateBubbles(cart.item_count);
          });
        });
      });
    }
  };

  /* ===== Product Form (AJAX Add to Cart) ===== */
  var ProductForm = {
    init: function() {
      var self = this;
      qsa('form[action="/cart/add"]').forEach(function(form) {
        on(form, 'submit', function(e) {
          e.preventDefault();
          var formData = new FormData(form);
          var id = formData.get('id');
          var qty = parseInt(formData.get('quantity')) || 1;
          var btn = form.querySelector('[name="add"]');
          var label = btn ? (btn.querySelector('.add-to-cart-text') || btn) : null;
          var originalLabel = label ? label.innerHTML : '';
          if (btn) { btn.disabled = true; label.textContent = 'Adding...'; }

          Cart.add(id, qty).then(function() {
            if (btn) { btn.disabled = false; label.textContent = 'Added!'; }
            CartDrawer.open();
            setTimeout(function() {
              if (btn) label.innerHTML = originalLabel;
            }, 1500);
          }).catch(function() {
            if (btn) { btn.disabled = false; label.innerHTML = originalLabel; }
          });
        });
      });

      this.initQuickAdd();
    },

    initQuickAdd: function() {
      on(document, 'click', function(e) {
        var btn = e.target.closest('.quick-add-btn');
        if (!btn) return;
        e.preventDefault();
        e.stopPropagation();
        var id = btn.dataset.variantId;
        if (!id) return;
        btn.disabled = true;
        btn.textContent = 'Adding...';
        Cart.add(parseInt(id), 1).then(function() {
          btn.textContent = 'Added!';
          CartDrawer.open();
          setTimeout(function() { btn.textContent = 'Add to Cart'; btn.disabled = false; }, 1500);
        }).catch(function() {
          btn.textContent = 'Add to Cart';
          btn.disabled = false;
        });
      });
    }
  };

  /* ===== Variant Selector (PDP) ===== */
  var VariantSelector = {
    init: function() {
      var container = qs('.product-detail');
      if (!container) return;

      var variantsJSON = qs('[data-product-variants]', container);
      if (!variantsJSON) return;

      try { this.variants = JSON.parse(variantsJSON.textContent); }
      catch(e) { return; }

      this.form = qs('#product-form', container);
      this.variantInput = qs('#variant-id', this.form);
      this.addBtn = this.form ? this.form.querySelector('[name="add"]') : null;
      this.priceEl = qs('.product-price', container);
      this.comparePriceEl = qs('.product-compare-price', container);
      this.saveBadge = qs('.product-save-badge', container);
      this.mainImage = qs('#product-featured-image', container);
      this.priceDisplay = qs('.product-price-display', container);
      this.installmentInput = qs('#product-form-installment input[name="id"]', container);
      this.lowStockEl = qs('.product-low-stock', container);
      this.deliveryRow = qs('.product-delivery-row', container);
      this.stickyPrice = qs('.sticky-atc-price', container);
      this.stickyBtn = qs('.sticky-atc-btn', container);
      this.inventory = {};
      var inventoryJSON = qs('[data-variant-inventory]', container);
      if (inventoryJSON) {
        try { this.inventory = JSON.parse(inventoryJSON.textContent); } catch(e) {}
      }

      var self = this;
      qsa('.variant-option', this.form).forEach(function(input) {
        on(input, 'change', function() { self.onOptionChange(); });
      });

      this.initThumbnails(container);
      this.initQuantity(container);
      this.initTabs(container);
      this.initVariantLabels(container);
      this.initLightbox(container);
      this.updateOptionAvailability();
    },

    onOptionChange: function() {
      var opts = {};
      qsa('.variant-option:checked', this.form).forEach(function(r) {
        opts['option' + r.dataset.option] = r.value;
      });
      var variant = this.variants.find(function(v) {
        return (!opts.option1 || v.option1 === opts.option1) &&
               (!opts.option2 || v.option2 === opts.option2) &&
               (!opts.option3 || v.option3 === opts.option3);
      });
      if (variant) {
        this.updateVariant(variant);
      } else {
        this.setUnavailable();
      }
      this.updateOptionAvailability();
    },

    setUnavailable: function() {
      if (this.addBtn) {
        this.addBtn.disabled = true;
        var addText = this.addBtn.querySelector('.add-to-cart-text');
        if (addText) addText.textContent = 'Unavailable';
      }
      if (this.stickyBtn) { this.stickyBtn.disabled = true; this.stickyBtn.textContent = 'Unavailable'; }
      if (this.lowStockEl) this.lowStockEl.classList.add('hidden');
      if (this.deliveryRow) this.deliveryRow.classList.add('hidden');
    },

    // Strike through option values with no available variant, given the selections
    // in the options above them (option 1 is checked on its own, option 2 against
    // option 1, option 3 against options 1 and 2).
    updateOptionAvailability: function() {
      var self = this;
      if (!this.form) return;
      var selected = {};
      qsa('.variant-option:checked', this.form).forEach(function(r) {
        selected[r.dataset.option] = r.value;
      });
      qsa('.variant-option', this.form).forEach(function(input) {
        var position = parseInt(input.dataset.option, 10);
        var available = self.variants.some(function(v) {
          if (!v.available || v['option' + position] !== input.value) return false;
          for (var i = 1; i < position; i++) {
            if (selected[i] && v['option' + i] !== selected[i]) return false;
          }
          return true;
        });
        var label = input.nextElementSibling;
        if (label) label.classList.toggle('variant-option-label--unavailable', !available);
      });
    },

    updateVariant: function(v) {
      if (this.variantInput) this.variantInput.value = v.id;
      if (this.installmentInput) {
        this.installmentInput.value = v.id;
        this.installmentInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (this.deliveryRow) this.deliveryRow.classList.toggle('hidden', !v.available);
      if (this.stickyPrice) this.stickyPrice.textContent = formatMoney(v.price);
      if (this.stickyBtn) {
        this.stickyBtn.disabled = !v.available;
        this.stickyBtn.textContent = v.available ? 'Add to Cart' : 'Out of Stock';
      }
      if (this.lowStockEl) {
        var qty = this.inventory[String(v.id)];
        var showLow = v.available && typeof qty === 'number' && qty > 0;
        this.lowStockEl.classList.toggle('hidden', !showLow);
        if (showLow) {
          var lowText = qs('.product-low-stock-text', this.lowStockEl);
          if (lowText) lowText.textContent = 'Only ' + qty + ' left in stock';
        }
      }
      if (this.priceEl) this.priceEl.textContent = formatMoney(v.price);
      if (this.priceDisplay) this.priceDisplay.textContent = formatMoney(v.price);
      if (this.comparePriceEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          this.comparePriceEl.textContent = formatMoney(v.compare_at_price);
          this.comparePriceEl.classList.remove('hidden');
        } else {
          this.comparePriceEl.classList.add('hidden');
        }
      }
      if (this.saveBadge) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          var pct = Math.round(((v.compare_at_price - v.price) / v.compare_at_price) * 100);
          this.saveBadge.textContent = 'Save ' + pct + '%';
          this.saveBadge.classList.remove('hidden');
        } else {
          this.saveBadge.classList.add('hidden');
        }
      }
      if (this.addBtn) {
        this.addBtn.disabled = !v.available;
        var addText = this.addBtn.querySelector('.add-to-cart-text');
        if (addText) {
          if (v.available) {
            addText.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="8" cy="21" r="1"/><circle cx="19" cy="21" r="1"/><path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12"/></svg> Add to Cart';
          } else {
            addText.textContent = 'Out of Stock';
          }
        }
      }
      if (v.featured_image && this.mainImage) {
        this.mainImage.src = v.featured_image.src;
      }
      var url = new URL(window.location);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    },

    initThumbnails: function(container) {
      var mainImg = qs('#product-featured-image', container);
      var trigger = qs('#product-image-trigger', container);
      qsa('.thumbnail', container).forEach(function(btn) {
        on(btn, 'click', function() {
          if (mainImg) mainImg.src = this.dataset.imageUrl;
          if (trigger && this.dataset.fullUrl) trigger.dataset.fullSrc = this.dataset.fullUrl;
          qsa('.thumbnail', container).forEach(function(b) {
            b.classList.remove('border-accent');
            b.classList.add('border-border');
          });
          this.classList.remove('border-border');
          this.classList.add('border-accent');
        });
      });
    },

    initQuantity: function(container) {
      qsa('.qty-btn', container).forEach(function(btn) {
        on(btn, 'click', function() {
          var wrapper = this.parentElement;
          var input = wrapper.querySelector('input[name="quantity"]');
          var display = wrapper.querySelector('.qty-display');
          if (!input) return;
          var val = parseInt(input.value) || 1;
          if (this.dataset.action === 'plus') { val = val + 1; }
          else { val = Math.max(1, val - 1); }
          input.value = val;
          if (display) display.textContent = val;
        });
      });
    },

    initTabs: function(container) {
      qsa('.product-tab', container).forEach(function(tab) {
        on(tab, 'click', function() {
          var target = this.dataset.tab;
          qsa('.product-tab', container).forEach(function(t) {
            t.classList.remove('bg-foreground', 'text-background', 'shadow-sm');
            t.classList.add('text-muted-foreground');
          });
          qsa('.product-tab-content', container).forEach(function(c) { c.classList.add('hidden'); });
          this.classList.add('bg-foreground', 'text-background', 'shadow-sm');
          this.classList.remove('text-muted-foreground');
          var panel = qs('#tab-' + target, container);
          if (panel) panel.classList.remove('hidden');
        });
      });
    },

    initVariantLabels: function(container) {
      qsa('.variant-option', container).forEach(function(input) {
        on(input, 'change', function() {
          var group = this.closest('.flex.flex-wrap');
          if (!group) return;
          qsa('.variant-option-label', group).forEach(function(label) {
            label.classList.remove('border-accent', 'bg-accent/10', 'text-accent', 'font-medium');
            label.classList.add('border-border');
          });
          var label = this.nextElementSibling;
          if (label) {
            label.classList.add('border-accent', 'bg-accent/10', 'text-accent', 'font-medium');
            label.classList.remove('border-border');
          }
        });
        if (input.checked) {
          var label = input.nextElementSibling;
          if (label) {
            label.classList.add('border-accent', 'bg-accent/10', 'text-accent', 'font-medium');
            label.classList.remove('border-border');
          }
        }
      });
    },

    initLightbox: function(container) {
      var trigger = qs('#product-image-trigger', container);
      var lightbox = qs('#product-lightbox');
      if (!trigger || !lightbox) return;

      var lbImg = qs('#product-lightbox-img', lightbox);
      var closeBtn = qs('.product-lightbox__close', lightbox);
      var backdrop = qs('.product-lightbox__backdrop', lightbox);
      var prevBtn = qs('.product-lightbox__prev', lightbox);
      var nextBtn = qs('.product-lightbox__next', lightbox);

      var images = [];
      var currentIndex = 0;
      try {
        var jsonEl = qs('#product-images-json');
        if (jsonEl) images = JSON.parse(jsonEl.textContent);
      } catch(e) {}

      function showImage(index) {
        if (!images.length || !lbImg) return;
        currentIndex = (index + images.length) % images.length;
        lbImg.src = images[currentIndex].url;
        lbImg.alt = images[currentIndex].alt || '';
        if (prevBtn) prevBtn.style.display = images.length > 1 ? '' : 'none';
        if (nextBtn) nextBtn.style.display = images.length > 1 ? '' : 'none';
      }

      function findCurrentIndex() {
        var currentSrc = trigger.dataset.fullSrc || '';
        for (var i = 0; i < images.length; i++) {
          if (images[i].url === currentSrc) return i;
        }
        return 0;
      }

      function openLightbox() {
        if (!images.length) return;
        currentIndex = findCurrentIndex();
        showImage(currentIndex);
        lightbox.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      }

      function closeLightbox() {
        lightbox.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      }

      on(trigger, 'click', openLightbox);
      if (closeBtn) on(closeBtn, 'click', closeLightbox);
      if (backdrop) on(backdrop, 'click', closeLightbox);
      if (prevBtn) on(prevBtn, 'click', function() { showImage(currentIndex - 1); });
      if (nextBtn) on(nextBtn, 'click', function() { showImage(currentIndex + 1); });
      document.addEventListener('keydown', function(e) {
        if (lightbox.getAttribute('aria-hidden') !== 'false') return;
        if (e.key === 'Escape') closeLightbox();
        if (e.key === 'ArrowLeft') showImage(currentIndex - 1);
        if (e.key === 'ArrowRight') showImage(currentIndex + 1);
      });
    }
  };

  /* ===== Configuration Select (PDP): each configuration is its own product ===== */
  var ConfigSelect = {
    init: function() {
      qsa('.config-select').forEach(function(sel) {
        on(sel, 'change', function() {
          if (this.value) window.location.href = this.value;
        });
      });
    }
  };

  /* ===== Delivery Estimate (PDP) ===== */
  var DeliveryEstimate = {
    init: function() {
      qsa('.product-delivery-estimate').forEach(function(el) {
        var min = parseInt(el.dataset.minDays, 10);
        var max = parseInt(el.dataset.maxDays, 10);
        if (!min || !max) return;
        var fmt = { weekday: 'short', month: 'short', day: 'numeric' };
        var from = DeliveryEstimate.addBusinessDays(new Date(), min).toLocaleDateString('en-US', fmt);
        var to = DeliveryEstimate.addBusinessDays(new Date(), max).toLocaleDateString('en-US', fmt);
        el.textContent = min === max ? from : from + ' – ' + to;
      });
    },

    addBusinessDays: function(date, days) {
      var d = new Date(date.getTime());
      while (days > 0) {
        d.setDate(d.getDate() + 1);
        if (d.getDay() !== 0 && d.getDay() !== 6) days--;
      }
      return d;
    }
  };

  /* ===== Sticky Add to Cart (PDP, mobile) ===== */
  var StickyAddToCart = {
    init: function() {
      var bar = qs('[data-sticky-atc]');
      var mainBtn = qs('#product-form [name="add"]');
      if (!bar || !mainBtn) return;
      var btn = qs('.sticky-atc-btn', bar);
      var ticking = false;

      function update() {
        ticking = false;
        // Only show once the main button has scrolled up out of view.
        var show = mainBtn.getBoundingClientRect().bottom < 0;
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        document.body.classList.toggle('has-sticky-atc', show);
        if (btn) btn.tabIndex = show ? 0 : -1;
      }

      on(window, 'scroll', function() {
        if (!ticking) { ticking = true; requestAnimationFrame(update); }
      }, { passive: true });
      update();
    }
  };

  /* ===== Product Recommendations ===== */
  var ProductRecommendations = {
    init: function() {
      qsa('.related-products[data-url]').forEach(function(section) {
        fetch(section.dataset.url)
          .then(function(r) { return r.text(); })
          .then(function(html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var fresh = qs('.related-products', doc);
            if (fresh && fresh.innerHTML.trim().length) {
              section.innerHTML = fresh.innerHTML;
              section.classList.remove('hidden');
            }
          })
          .catch(function() {});
      });
    }
  };

  /* ===== Mobile Search ===== */
  var MobileSearch = {
    init: function() {
      var trigger = qs('.mobile-search-trigger');
      var panel = qs('.mobile-search');
      if (!trigger || !panel) return;

      on(trigger, 'click', function() {
        var willOpen = panel.classList.contains('hidden');
        panel.classList.toggle('hidden');
        trigger.setAttribute('aria-expanded', willOpen);
        if (willOpen) {
          var input = qs('input[type="search"]', panel);
          if (input) input.focus();
        }
      });
    }
  };

  /* ===== Mobile Menu ===== */
  var MobileMenu = {
    init: function() {
      var trigger = qs('.mobile-menu-trigger');
      var menu = qs('.mobile-menu');
      if (!trigger || !menu) return;

      on(trigger, 'click', function() {
        var isOpen = !menu.classList.contains('hidden');
        menu.classList.toggle('hidden');
        trigger.setAttribute('aria-expanded', !isOpen);
      });
    }
  };

  /* ===== Mobile Filter Drawer ===== */
  var FilterDrawer = {
    init: function() {
      var trigger = qs('.filter-drawer-trigger');
      var drawer = qs('#filter-drawer');
      if (!trigger || !drawer) return;

      var overlay = qs('.filter-drawer-overlay', drawer);
      var panel = qs('.filter-drawer-panel', drawer);
      var self = this;
      this.drawer = drawer;
      this.panel = panel;

      on(trigger, 'click', function() { self.open(); });
      if (overlay) on(overlay, 'click', function() { self.close(); });
      qsa('.filter-drawer-close', drawer).forEach(function(btn) {
        on(btn, 'click', function() { self.close(); });
      });
    },

    open: function() {
      if (!this.drawer) return;
      this.drawer.classList.remove('hidden');
      document.body.classList.add('overflow-hidden');
    },

    close: function() {
      if (!this.drawer) return;
      this.drawer.classList.add('hidden');
      document.body.classList.remove('overflow-hidden');
    }
  };

  /* ===== Predictive Search ===== */
  var PredictiveSearch = {
    init: function() {
      var self = this;
      qsa('.predictive-search-wrapper').forEach(function(wrapper) {
        var input = qs('.predictive-search-input', wrapper);
        var results = qs('.predictive-search-results', wrapper);
        if (!input || !results) return;

        on(input, 'input', debounce(function() {
          var q = input.value.trim();
          if (q.length < 2) { results.classList.add('hidden'); results.innerHTML = ''; return; }
          self.search(q, results);
        }, 300));

        on(input, 'focus', function() {
          if (results.innerHTML.trim()) results.classList.remove('hidden');
        });

        on(document, 'click', function(e) {
          if (!wrapper.contains(e.target)) {
            results.classList.add('hidden');
          }
        });
      });
    },

    search: function(q, results) {
      var self = this;
      fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6')
        .then(function(r) { return r.json(); })
        .then(function(data) {
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          self.renderResults(products, q, results);
        });
    },

    renderResults: function(products, q, results) {
      if (!products.length) {
        results.innerHTML = '<div class="p-4 text-sm text-muted-foreground">No results for "' + q + '"</div>';
        results.classList.remove('hidden');
        return;
      }
      var html = '';
      products.forEach(function(p) {
        var img = p.image ? '<img src="' + p.image + '" alt="" class="w-10 h-10 object-cover rounded">' : '<div class="w-10 h-10 bg-muted rounded"></div>';
        html += '<a href="' + p.url + '" class="flex items-center gap-3 p-3 hover:bg-muted transition">' +
          img + '<div class="flex-1 min-w-0"><p class="text-sm font-medium truncate">' + p.title + '</p>' +
          '<p class="text-xs text-primary">' + p.price + '</p></div></a>';
      });
      html += '<a href="/search?q=' + encodeURIComponent(q) + '" class="block p-3 text-center text-sm text-primary font-medium border-t border-border">View all results</a>';
      results.innerHTML = html;
      results.classList.remove('hidden');
    }
  };

  /* ===== Collection Sort ===== */
  var CollectionSort = {
    init: function() {
      var select = qs('#sort-by');
      if (!select) return;
      on(select, 'change', function() {
        var url = new URL(window.location);
        url.searchParams.set('sort_by', this.value);
        window.location.href = url.toString();
      });
    }
  };

  /* ===== Toast Notifications ===== */
  var Toast = {
    show: function(message, type) {
      var existing = qs('.toast-notification');
      if (existing) existing.remove();

      var toast = document.createElement('div');
      toast.className = 'toast-notification fixed bottom-4 right-4 z-[200] px-4 py-3 rounded-lg shadow-lg text-sm font-medium animate-slide-in';
      if (type === 'error') {
        toast.style.backgroundColor = 'hsl(var(--destructive))';
        toast.style.color = 'hsl(var(--destructive-foreground))';
      } else {
        toast.style.backgroundColor = 'hsl(var(--foreground))';
        toast.style.color = 'hsl(var(--background))';
      }
      toast.textContent = message;
      document.body.appendChild(toast);
      setTimeout(function() { toast.remove(); }, 3000);
    }
  };

  /* ===== Announcement Bar Close ===== */
  var AnnouncementBar = {
    init: function() {
      var closeBtn = qs('.announcement-close');
      if (!closeBtn) return;
      on(closeBtn, 'click', function() {
        var bar = this.closest('section');
        if (bar) bar.style.display = 'none';
      });
    }
  };

  /* ===== Count Up Animation ===== */
  var CountUp = {
    init: function() {
      var els = qsa('[data-count-up]');
      if (!els.length) return;

      var self = this;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (reduce || typeof IntersectionObserver === 'undefined') {
        els.forEach(function(el) { self.animate(el, true); });
        return;
      }

      var observer = new IntersectionObserver(function(entries, obs) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            self.animate(entry.target, false);
            obs.unobserve(entry.target);
          }
        });
      }, { threshold: 0.3 });

      els.forEach(function(el) { observer.observe(el); });
    },

    animate: function(el, instant) {
      var target = parseFloat(String(el.getAttribute('data-count-up') || '').replace(/[^0-9.]/g, '')) || 0;
      var duration = parseInt(el.getAttribute('data-count-duration'), 10) || 2000;

      if (instant || duration <= 0) {
        el.textContent = target.toLocaleString('en-US');
        return;
      }

      var startTime = null;
      function frame(now) {
        if (startTime === null) startTime = now;
        var progress = Math.min((now - startTime) / duration, 1);
        el.textContent = Math.round(target * progress).toLocaleString('en-US');
        if (progress < 1) {
          requestAnimationFrame(frame);
        } else {
          el.textContent = target.toLocaleString('en-US');
        }
      }
      requestAnimationFrame(frame);
    }
  };

  /* ===== Judge.me review markup rendered from metafields (no app script) ===== */
  var Reviews = {
    init: function() {
      qsa('.rt-reviews .jdgm-rev__timestamp').forEach(function(el) {
        var raw = el.getAttribute('data-content') || '';
        var d = new Date(raw.replace(' UTC', 'Z').replace(' ', 'T'));
        el.textContent = isNaN(d) ? raw.slice(0, 10) : d.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
        el.classList.remove('jdgm-spinner');
      });
      qsa('.rt-reviews .jdgm-rev__reply').forEach(function(el) {
        if (!el.textContent.trim()) el.remove();
      });
    }
  };

  /* ===== Collection budget chips: keep the current one visible in the scrolling row on phones ===== */
  var CollectionChips = {
    init: function() {
      var row = qs('.collection-chips');
      var current = row && qs('[aria-current="page"]', row);
      if (!row || !current || row.scrollWidth <= row.clientWidth) return;
      row.scrollLeft = Math.max(0, current.offsetLeft - row.offsetLeft - 16);
    }
  };

  /* ===== Init on DOMContentLoaded ===== */
  function init() {
    CartDrawer.init();
    ProductForm.init();
    VariantSelector.init();
    ConfigSelect.init();
    DeliveryEstimate.init();
    StickyAddToCart.init();
    ProductRecommendations.init();
    MobileMenu.init();
    MobileSearch.init();
    FilterDrawer.init();
    PredictiveSearch.init();
    CollectionSort.init();
    AnnouncementBar.init();
    CountUp.init();
    Reviews.init();
    CollectionChips.init();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.theme = { Cart: Cart, CartDrawer: CartDrawer, Toast: Toast, formatMoney: formatMoney };
})();
